import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';

import { VsApiError } from './classes/VsApiError';
import { VsGraphQLError } from './classes/VsGraphQLError';
import { RtkErrorResponseOfVsApi, RtkErrorResponseOfVsGraphQL } from './type';

export type PossibleRtkQueryErrors =
  | FetchBaseQueryError
  | RtkErrorResponseOfVsApi
  | RtkErrorResponseOfVsGraphQL;

type PossibleErrorInstance = VsApiError | VsGraphQLError;

const map = new WeakMap<PossibleRtkQueryErrors, PossibleErrorInstance>();

export function getErrorInstance(error: PossibleRtkQueryErrors) {
  return map.get(error);
}

export function setErrorInstance(
  error: PossibleRtkQueryErrors,
  errorInstance: PossibleErrorInstance
) {
  map.set(error, errorInstance);
}
